module.exports = __webpack_public_path__ + "img/buy-oc-plus-congratulations.f358105.svg";